import { NonIndexRouteObject } from 'react-router';

import { HomeRoutes } from '../../../../../RouteConstants';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { RouteErrorPage } from '@components/ErrorBoundary';

// eOauth SSO routes
export const OAuthLoginPublicRoutes: NonIndexRouteObject[] = [
  {
    path: HomeRoutes.oAuthcb,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    async lazy() {
      const HomeLayoutLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
      ).default;

      const TenantSelectLogin = (
        await import('../../../../../../Modules/Authentication/Login/SSO/TenantSelectLogin')
      ).default;
      const { SSOLoginAction } = await import(
        '../../../../../../Modules/Authentication/Login/SSO/utils/ssoLogin.action'
      );
      const { SSOLoginLoader } = await import(
        '../../../../../../Modules/Authentication/Login/SSO/utils/ssoLogin.loader'
      );

      return {
        element: <HomeLayoutLoginRoutes content={<TenantSelectLogin />} />,
        errorElement: <RouteErrorPage />,
        action: SSOLoginAction,
        loader: SSOLoginLoader,
      };
    },
  },
  {
    path: HomeRoutes.eoAuthLogin,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    async lazy() {
      const LoginRedirect = (await import('../../../../../../Modules/LoginRedirect/LoginRedirect'))
        .default;

      return {
        element: <LoginRedirect />,
        errorElement: <RouteErrorPage />,
      };
    },
  },
  {
    path: HomeRoutes.eoAuthLogout,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    async lazy() {
      const LoginRedirect = (await import('../../../../../../Modules/LoginRedirect/LoginRedirect'))
        .default;

      return {
        element: <LoginRedirect requestType="logout" />,
        errorElement: <RouteErrorPage />,
      };
    },
  },
  {
    path: HomeRoutes.ssoLogout,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    async lazy() {
      const HomeLayoutLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
      ).default;
      const LogoutMessageSSO = (
        await import('../../../../../../Modules/Authentication/Logout/SSO/LogoutMessageSSO')
      ).default;

      return {
        element: <HomeLayoutLoginRoutes content={<LogoutMessageSSO />} />,
        errorElement: <RouteErrorPage />,
      };
    },
  },
];
